import React, { useState } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { FEATURE_TYPES } from '../../../../lib/constants'
import actions from './actions'
import Button from '../../../Button'
import Color from 'color'
import FeatureColorEditor from './FeatureColorEditor'
import FeatureLineWeightEditor from './FeatureLineWeightEditor'
import FeatureRecentStyles from './FeatureRecentStyles'
import FeatureTitleEditor from './FeatureTitleEditor'
import SidebarDetailHeader from '../../SidebarDetailHeader'
import SidebarBody from '../../SidebarBody'
import styles from './FeatureEditor.module.scss'
import X from '../../../../assets/svg/Feather/X'

export function FeatureEditor(props) {
	const [isFeatureSaveable, setIsFeatureSaveable] = useState(true)

	const selectColor = (color) => {
		color = new Color(color).rgb().color
		color.push(1)
		return color
	}

	const updateFeatureColor = (e) => {
		const newValue = selectColor(e.target.value)
		props.updateFeatureColor(props.selectedFeature, newValue)
	}

	const updateFeatureTitle = (e) => {
		setIsFeatureSaveable(e.target.value.trim() ? true : false)
		props.updateFeatureTitle(props.selectedFeature, e.target.value)
	}

	const updateFeatureLineWeight = (selectedOption, selectedValue) => {
		props.updateFeatureLineWeight(props.selectedFeature, selectedValue.value)
	}

	const saveFeature = () => {
		props.saveFeature(props.selectedFeature, props.hasFeatureErrored, props.featureErrorId)
	}

	return (
		<>
			<SidebarDetailHeader title={`Edit ${props.selectedFeatureType}`} />
			<SidebarBody className={styles.bodyContainer}>
				<FeatureTitleEditor feature={props.selectedFeature} onChange={updateFeatureTitle} />
				{props.selectedFeatureType === FEATURE_TYPES.Point ? <FeatureRecentStyles /> : <FeatureLineWeightEditor feature={props.selectedFeature} onChange={updateFeatureLineWeight} />}
				<FeatureColorEditor feature={props.selectedFeature} onChange={updateFeatureColor} />
				<div className={styles.buttonFooter}>
					<Button onClick={props.cancelEdit} theme={Button.THEME.outlinePrimary}>
						Cancel
					</Button>
					<Button onClick={saveFeature} disabled={!isFeatureSaveable} theme={Button.THEME.solidPrimary}>
						Save
					</Button>
				</div>
			</SidebarBody>
		</>
	)
}

FeatureEditor.propTypes = {
	featureErrorId: PropTypes.string,
	hasFeatureErrored: PropTypes.bool,
	selectedFeature: PropTypes.object,
	selectedFeatureType: PropTypes.string,

	//actions
	cancelEdit: PropTypes.func,
	saveFeature: PropTypes.func,
	updateFeatureColor: PropTypes.func,
	updateFeatureIcon: PropTypes.func,
	updateFeatureLineWeight: PropTypes.func,
	updateFeatureTitle: PropTypes.func,
}

export default connect((model) => {
	const { featureErrorId, hasFeatureErrored, selectedFeature } = model.features
	const selectedFeatureType = selectedFeature.properties.ghType
	return {
		featureErrorId,
		hasFeatureErrored,
		selectedFeature,
		selectedFeatureType,
	}
}, actions)(FeatureEditor)
